// extracted by mini-css-extract-plugin
export default {"img":"Avatar_img__+nQO+","initials":"Avatar_initials__B+PE-"};